/* eslint-disable no-param-reassign */
import { extend } from 'umi-request';
import qs from 'qs';
import { notification, message } from 'antd';
/**
 * 异常处理程序
 */

const appid = 'pc-nirvana';
const errorHandler = async (error) => {
  const { response } = error;
  let res = { status: false };

  // eslint-disable-next-line no-console
  console.log('error-------->', error);

  if (response && response.status) {
    res = await response.clone().json();
    message.error(res.error.msg);
  } else if (!response) {
    // 无response，强制关闭全局loading
    notification.error({
      description: '您的网络发生异常，无法连接服务器',
      message: '网络异常',
    });
  }

  return res;
};
const baseConfig = {
  // eslint-disable-next-line
  prefix: `${BASE_URL_COLOR}`,
  errorHandler,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'Content-Type': 'application/x-www-form-urlencoded',
  },
  // 默认错误处理
  credentials: 'include', // 默认请求是否带上cookie
  isShowErrMsg: true, // 默认带错误时tip 提示
  isAutoReload: false, // 错误码为255时是否，刷新
  isAutoLoading: false, // 是否展示全局loading
};

/**
 * 配置request请求时的默认参数
 */
const request = extend(baseConfig);
/**
 * 请求拦截
 */
request.interceptors.request.use(
  (url, options) => {
    const {
      method,
      params = {},
      data = {},
      pfinderParams = {},
    } = options;

    // color网关 appId
    const baseParams = { appid };
    if (method === 'get') options.params = { ...params, ...baseParams, _t: new Date().getTime() };
    if (method === 'post') {
      if (data.functionId && data.body) {
        const requestData = {
          functionId: data.functionId,
          body: JSON.stringify({
            ...data.body,
            ...data,
            ...baseParams,
          }),
          appid,
          ...pfinderParams,
        };
        options.data = qs.stringify(requestData);
      } else {
        options.data = qs.stringify({
          ...data,
          ...baseParams,
        });
      }
    }
    return { url, options };
  },
  { global: false }
);

/**
 * 响应拦截
 */
request.interceptors.response.use(
  async (response, options) => {
    // eslint-disable-next-line no-console
    console.log('response-------->', response);
    let res = null;
    const { isShowErrMsg } = options;
    try {
      res = await response.clone().json();
      let status;
      if (res.status) {
        status = true;
      } else if (res.code) {
        status = res.code === '0';
      } else {
        status = false;
      }
      if (!status && isShowErrMsg) {
        message.error({
          content: res.error?.msg || res?.errMsg || '请求失败，请稍后再试',
          duration: 3,
        });
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('error', error);
    }
    return response;
  },
  { global: false }
);

export default request;
